import React from 'react';
import './ConfirmationMessage.css';

const ConfirmationMessage = ({ onClose, paymentMethod }) => {
    return (
        <div className="confirmation-popup">
            <div className="confirmation-box font-tiskani">
                <button
                    className="close-button"
                    onClick={onClose}
                    aria-label="Zatvori poruku potvrde"
                >
                    ×
                </button>
                <h4>Hvala na narudžbi!</h4>
                <p>Vaša narudžba je potvrđena. Potvrdu i upute poslali smo na Vašu e-mail adresu.</p>

                {paymentMethod === "Transakcijski račun" && (
                    <p><strong>Vaša narudžba bit će isporučena kad sredstva budu vidljiva na našem računu.</strong></p>
                )}
            </div>
        </div>
    );
};

export default ConfirmationMessage;
